




















































import { Component, Vue, Watch } from 'vue-property-decorator';
import ProfitLoss from '@/charts/ProfitLoss.vue';
import CompanyMixin from '@/mixins/CompanyMixin';

@Component({components: {ProfitLoss}})
export default class CardProfitLossDiagram extends CompanyMixin {
}
